import React from 'react';
import PropTypes from 'prop-types';

import LabelContent from './label_content';

const LabelTree = (props) => {
  const {
    activeLabelKey,
    expandedLabels,
    labelsTree,
    onLabelSelect,
    toggleExpand,
    panelId,
    ariaLabelledBy
  } = props;
  const renderedChildren = labelsTree.children.map((label, index) => <LabelTree key={`label-tree-${index}`} {...props} labelsTree={label} />);
  // Labels are converted from a flat list of labels, to a nested structure.  The root node is empty, but has 0 or more children.  So it is expected
  // to have an id of undefined here.
  if (labelsTree.id === undefined) {
    return (
      <ul
        aria-labelledby={ariaLabelledBy}
        className="labels-container"
        id={panelId}
      >
        {renderedChildren}
      </ul>
    );
  }
  const labelId = labelsTree.id;
  const activeClass = activeLabelKey === labelId ? 'active' : '';
  const expandedClass = expandedLabels[labelId] ? 'expanded' : '';
  const childCount = labelsTree.children.length;
  const { name, path } = labelsTree.attributes;
  const indentCounter = path.length - 1;
  const isExpanded = Boolean(expandedLabels[labelId]);
  const childrenPanelId = childCount > 0
    ? `label-children-panel-${String(labelId).replace(/[^a-zA-Z0-9_-]/g, '-')}`
    : undefined;
  return (
    <li key={labelId} className={`label-item ${activeClass} ${expandedClass}`}>
      <LabelContent
        key={labelId}
        childrenPanelId={childrenPanelId}
        hasChildren={childCount > 0}
        indentationLevel={indentCounter}
        isExpanded={isExpanded}
        labelId={labelId}
        name={name}
        onLabelSelect={onLabelSelect}
        toggleExpand={toggleExpand}
      />
      {childCount > 0 && (
        <div
          className="label-accordion-panel"
          hidden={!isExpanded}
          id={childrenPanelId}
        >
          {isExpanded ? (
            <ul className="labels-container">{renderedChildren}</ul>
          ) : null}
        </div>
      )}
    </li>
  );
};

LabelTree.propTypes = {
  activeLabelKey: PropTypes.string,
  ariaLabelledBy: PropTypes.string,
  expandedLabels: PropTypes.shape({}).isRequired,
  labelsTree: PropTypes.shape({}).isRequired,
  onLabelSelect: PropTypes.func.isRequired,
  panelId: PropTypes.string,
  toggleExpand: PropTypes.func.isRequired,
};

LabelTree.defaultProps = {
  activeLabelKey: null,
};

export default LabelTree;
